// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"970e1745","548":"1e76dea2","683":"fba747c9","732":"0381be40","977":"4ebae0fb"}[chunkId] + ".chunk.js";
};